import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { NotificationsService } from 'angular2-notifications';
import {CommonUtility, DataService, ServerConstantsService, WpPerson} from "../../shared";
import {ReferenceTableService} from "../../reference-table.service";


@Component({
  selector: 'admin-left-nav',
  templateUrl: './admin-left-nav.component.html',
  styleUrls: ['admin-left-nav.scss']
})

export class AdminLeftNavComponent implements OnInit {
  /*wpPersonId: string ='';
  referralId: string = '';
  wpPerson: WpPerson;*/
  @Input() path;
  ServerConstants: any;
  userActionNotificationsMap: any;
  sharedData: any;

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private commonUtil: CommonUtility,
    private refTableService: ReferenceTableService,
    private dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
  ) {
    this.ServerConstants = serverConstantsService.getConstants();
  }

  ngOnInit() {
      this.sharedData = this.dataService.getSharedDataObject();
      /*this.referralId = this.sharedData.get('referralId');
      this.wpPersonId = this.sharedData.get('wpPersonId');*/

      //Retrieve reference tables
      this.refTableService.currentMessage.subscribe((message) => {
          //Parse reference table data
          if(message && message.englishDropDown){
            this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(message.englishDropDown["USER-ACTION-NOTIFICATIONS"]);
          }
      });

      //Retrieve Person Data
      /*this.wpPerson = new WpPerson();
      this.http.post<WpPerson>(this.ServerConstants.SERVER_API_URL + '/persondata/load', parseInt(this.wpPersonId) ).subscribe(
          (data: WpPerson ) => {
              // convert date to the proper format for UI
              this.wpPerson = data;
          },response => {
              //Display Toast Error Notification
              this.notificationService.error('Person', this.userActionNotificationsMap.ERROR);
          },() => {
          });*/
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/admin-left-nav/admin-left-nav.component.ts